export default "__VITE_ASSET__eGre$D18__"